import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

function Modal({ isOpen, onClose, children, className = 'modal-content', overlayClassName = '' }) {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${overlayClassName}`.trim()}>
      <div className={className}>
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
};

export default Modal;
